<form [formGroup]="form" autocomplete="off">
  <div class="header-container">
    <p>* = required</p>
  </div>
  <div class="order-container">
    <div class="order-subcontainer">
      <div class="order-section">
        <h2>Medication</h2>

        <p-select inputId="medicationName" [options]="medications" filter="true" filterBy="id,name,controlledSubstance"
          placeholder="Select a medication *" [formControl]="medicationFormControl">
          <ng-template #selectedItem let-selectedOption>
            <div> {{ selectedOption.name }} ({{ selectedOption.id }}) </div>
          </ng-template>
          <ng-template let-med #item>
            <div> {{ med.name }} ({{ med.id }}) </div>
          </ng-template>
        </p-select>

        <p>Controlled substance: {{ medicationFormControl.value.controlledSubstance ? "Yes": "No" }}</p>

        <label for="route-dropdown">Route *&nbsp;</label>
        <p-select id="route-dropdown" placeholder="Select a medication to view routes"
          emptyMessage="No routes available for this medication" [autoDisplayFirst]="false" [options]="medRoutes"
          [formControl]="routeFormControl">
        </p-select>
      </div>

      <div class="order-section">
        <h2>Dosage</h2>
        @if (!isMealTimesOrSlidingScale) {
        <div class="dosage-container">
          <emr-input type="text" [control]="dosageFormControl" label="Dosage" placeholder="Enter dosage to administer"
            [required]="true" />
        </div>
        }

        <div class="slidingscale-and-mealtimes">
          @if (isSlidingScale) {
          <p-table [value]="slidingScaleTable" editMode="row" dataKey="key" class="slidingscale-table" size="small"
            [showGridlines]="true">
            <ng-template pTemplate="caption">
              <h3>
                <b>Sliding Scale</b>
                <p-button class="margin-left" label="New Row" icon="pi pi-plus" size="small"
                  (click)="onSlidingScaleNewRowAdd()" />
              </h3>
            </ng-template>
            <ng-template #header>
              <th class="slidingscale-column">BS</th>
              <th class="slidingscale-column">Units</th>
              <!-- actions column -- edit, delete -->
              <th class="slidingscale-column">Actions</th>
            </ng-template>
            <ng-template #body let-slidingScaleValue let-editing="editing" let-ri="rowIndex">
              <tr [pEditableRow]="slidingScaleValue">
                <td class="slidingscale-column">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input size="9" pInputText type="text" [(ngModel)]="slidingScaleValue.bs"
                        [ngModelOptions]="{standalone: true}" />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{slidingScaleValue.bs}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td class="slidingscale-column">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" [(ngModel)]="slidingScaleValue.units"
                        [ngModelOptions]="{standalone: true}" size="5" />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{slidingScaleValue.units}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td class="slidingscale-column">
                  <div class="flex items-center justify-center gap-2">
                    @if (!editing) {
                    <button pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                      (click)="onSlidingScaleRowEditInit(slidingScaleValue)" text rounded severity="secondary"></button>
                    <button pButton pRipple type="button" icon="pi pi-trash" (click)="onSlidingScaleRowDelete(ri)" text
                      rounded severity="secondary"></button>
                    } @else {
                    <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                      (click)="onSlidingScaleRowEditSave(slidingScaleValue)" text rounded severity="secondary"></button>
                    <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                      (click)="onSlidingScaleRowEditCancel(slidingScaleValue, ri)" text rounded
                      severity="secondary"></button>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          }

          @if (isMealTimes) {
          <p-table [value]="mealTimesTable" editMode="row" dataKey="key" class="mealtimes-table" size="small"
            [showGridlines]="true">
            <ng-template pTemplate="caption">
              <h3>
                <b>Meal Time Coverage</b>
                <p-button class="margin-left" label="New Row" icon="pi pi-plus" size="small"
                  (click)="onMealTimesNewRowAdd()" />
              </h3>
            </ng-template>
            <ng-template #header>
              <th class="mealtimes-column">Carbs</th>
              <th class="mealtimes-column">Units</th>
              <!-- actions column -- edit, delete -->
              <th class="mealtimes-column">Actions</th>
            </ng-template>
            <ng-template #body let-mealTimesValue let-editing="editing" let-ri="rowIndex">
              <tr [pEditableRow]="mealTimesValue">
                <td class="mealtimes-column">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" [(ngModel)]="mealTimesValue.carbs"
                        [ngModelOptions]="{standalone: true}" size="4" />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{mealTimesValue.carbs}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td class="mealtimes-column">
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText type="text" [(ngModel)]="mealTimesValue.units"
                        [ngModelOptions]="{standalone: true}" size="4" />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{mealTimesValue.units}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td class="mealtimes-column">
                  <div class="flex items-center justify-center gap-2">
                    @if (!editing) {
                    <button pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                      (click)="onMealTimesRowEditInit(mealTimesValue)" text rounded severity="secondary"></button>
                    <button pButton pRipple type="button" pInitEditableRow icon="pi pi-trash"
                      (click)="onMealTimesRowDelete(ri)" text rounded severity="secondary"></button>
                    } @else {
                    <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                      (click)="onMealTimesRowEditSave(mealTimesValue)" text rounded severity="secondary"></button>
                    <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                      (click)="onMealTimesRowEditCancel(mealTimesValue, ri)" text rounded severity="secondary"></button>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          }
        </div>
      </div>

      <div class="order-section">
        <h2>Order Schedule</h2>
        <div>
          <emr-input type="select" [control]="orderTypeFormControl" [options]="orderTypeOptions"
            placeholder="Select order type *" />
          @if (isQD) {
          <emr-input type="time" label="Scheduled for" [control]="startDateFormControl" placeholder="Time"
            [required]="true" />
          }

          @if (isPRN) {
          <emr-input type="time" label="Last Given at" [control]="prnLastGivenTimeFormControl" placeholder="Time" />
          <emr-input type="text" label="Dosing Instructions" [control]="prnDosingInstrFormControl"
            placeholder="Enter dosing instructions" [required]="true" />
          }

          @if (isTypeSet && !isPRN) {
          @for (doseTime of providerOrder2MedSchedule(); track $index) {
          <p>{{ doseTime }}</p>
          }
          }
        </div>
      </div>
    </div>

    <div class="order-subcontainer">
      <h2>Order/Additional Instructions</h2>
      <emr-input type="textarea" [control]="orderFormControl" placeholder="Enter instructions here" />
    </div>
  </div>

  <div class="signature-container">
    <h2>Signature</h2>
    <emr-input type="text" width="25%" [control]="signatureFormControl" placeholder="Signature *" />
  </div>

</form>